export const CONTACT_EMAIL = 'mfarrell174@gmail.com'